{
  "name": "celo-desktop",
  "version": "3.13.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "prestart": "npm run common-prebuild-script",
    "start": "ng serve -c devlocal",
    "start-dev": "ng serve -c devlocal",
    "start-staging": "ng serve -c staging",
    "start-prodtest": "ng serve -c productiontest",
    "start-prod": "ng serve -c production",
    "common-prebuild-script": "tsx scripts/prebuild-script.ts",
    "prebuild": "npm run common-prebuild-script",
    "prebuild-dev-local": "npm run common-prebuild-script",
    "prebuild-dev-hosted": "npm run common-prebuild-script",
    "prebuild-staging": "npm run common-prebuild-script",
    "prebuild-prodtest": "npm run common-prebuild-script",
    "prebuild-prod": "npm run common-prebuild-script",
    "build": "ng build",
    "build-dev-local": "ng build -c devlocal --output-path dist/dev",
    "build-dev-hosted": "ng build -c devhosted --output-path dist/dev",
    "build-staging": "ng build -c staging --output-path dist/staging ",
    "build-prodtest": "ng build -c productiontest --output-path dist/prodtest",
    "build-prod": "ng build -c production --output-path dist/prod",
    "test": "ng test",
    "test:ci": "ng test --watch=false",
    "test:coverage": "ng test --watch=false --coverage",
    "e2e": "playwright test",
    "e2e:lint": "eslint e2e playwright.config.ts",
    "e2e:report": "tsx e2e/support/show-report.ts",
    "e2e:typecheck": "tsc --noEmit -p e2e/tsconfig.json",
    "lint": "ng lint --fix",
    "prettier": "npx prettier ./src --check",
    "prettify": "npx prettier ./src --write",
    "docs:json": "compodoc -p ./tsconfig.json -e json -d .",
    "storybook": "ng run celo-desktop:storybook",
    "build-storybook": "npm run docs:json && ng run celo-desktop:build-storybook",
    "chromatic": "npx chromatic --project-token=0d58163a35bc --storybook-build-dir storybook-static",
    "check-circular": "npx madge --circular --extensions ts ./",
    "version": "npm run common-prebuild-script && git add src/assets/version.json build-data.json"
  },
  "private": true,
  "engines": {
    "node": "^22.0.0",
    "npm": "^10.0.0"
  },
  "dependencies": {
    "@angular/animations": "22.1.3",
    "@angular/cdk": "^22.1.4",
    "@angular/common": "22.1.3",
    "@angular/compiler": "^22.1.3",
    "@angular/core": "22.1.3",
    "@angular/forms": "^22.1.3",
    "@angular/material": "^22.1.4",
    "@angular/material-luxon-adapter": "^22.1.4",
    "@angular/platform-browser": "^22.1.3",
    "@angular/platform-browser-dynamic": "22.1.3",
    "@angular/platform-server": "^22.1.3",
    "@angular/router": "^22.1.3",
    "@corti/sdk": "^0.6.1",
    "@ctrl/ngx-emoji-mart": "^9.3.0",
    "@fontsource/material-icons": "^5.2.5",
    "@fontsource/material-icons-outlined": "^5.3.0",
    "@fontsource/material-icons-round": "^5.3.0",
    "@fontsource/roboto": "^5.2.5",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.6",
    "@microsoft/applicationinsights-web": "^3.3.6",
    "@microsoft/signalr": "^10.0.0",
    "@storybook/addon-a11y": "^10.5.10",
    "@storybook/addon-docs": "^10.5.10",
    "@teamhive/lottie-player": "^1.0.0",
    "@zoom/videosdk": "^1.12.14",
    "angular-oauth2-oidc": "^22.0.2",
    "bootstrap": "^5.3.5",
    "bowser": "^2.14.1",
    "chromatic": "^6.10.1",
    "core-js": "^3.25.3",
    "country-codes-list": "^1.6.8",
    "dateformat": "^5.0.3",
    "deep-equal": "^2.2.3",
    "dompurify": "^3.2.7",
    "file-saver": "^2.0.5",
    "firebase": "^12.18.0",
    "intl": "^1.2.5",
    "jose": "^4.14.4",
    "jszip": "^3.10.1",
    "libphonenumber-js": "^1.13.7",
    "linkify-string": "^4.1.1",
    "linkifyjs": "^4.1.1",
    "luxon": "^3.7.2",
    "marked": "^16.4.0",
    "match-sorter": "^6.3.1",
    "mediabunny": "^1.15.2",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-avatars": "^1.10.2",
    "ngx-infinite-scroll": "^22.0.0",
    "rxjs": "^7.8.2",
    "stream": "0.0.2",
    "utility-types": "^3.11.0",
    "uuid": "^8.3.2",
    "worker-loader": "^3.0.8",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.2201.6",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.1.6",
    "@angular/cli": "^22.1.6",
    "@angular/compiler-cli": "^22.1.3",
    "@angular/language-service": "^22.1.3",
    "@babel/core": "^7.18.9",
    "@compodoc/compodoc": "^2.0.0",
    "@playwright/test": "1.62.1",
    "@storybook/angular": "^10.5.10",
    "@storybook/cli": "^10.5.10",
    "@types/chart.js": "^2.7.40",
    "@types/deep-equal": "^1.0.4",
    "@types/file-saver": "^2.0.0",
    "@types/luxon": "^3.2.0",
    "@types/node": "^22.15.3",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^22.1.0",
    "babel-loader": "^8.2.5",
    "eslint": "^9.0.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-storybook": "^10.5.10",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "prettier": "^3.2.4",
    "storybook": "^10.5.10",
    "ts-node": "^7.0.1",
    "tsx": "^4.19.3",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.0.0",
    "typescript-strict-plugin": "^2.4.4",
    "vitest": "^4.1.11"
  },
  "overrides": {
    "ngx-avatars": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    }
  },
  "browserslist": [
    "defaults"
  ],
  "readme": "ERROR: No README data found!"
}
